import React, {Component} from 'react';
import PropTypes from 'prop-types';

class Pagination extends Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.renderItems = this
            .renderItems
            .bind(this);
        this.onChange = this
            .onChange
            .bind(this);
        this.prev = this
            .prev
            .bind(this);
        this.getPagesCount = this
            .getPagesCount
            .bind(this);
        this.next = this
            .next
            .bind(this);
    }

    componentWillMount() {
        this.setState({selected: this.props.selected});
    }

    onChange({item}) {
        this.setState({
            selected: item + 1
        }, () => {
            this
                .props
                .onChange({
                    page: item + 1
                });
        });
    }

    getPagesCount() {
        let count = Math.floor(this.props.count / this.props.perPage);
        if (this.props.count % this.props.perPage !== 0) 
            count++;
        return count;
    }

    next() {
        let selected = this.state.selected;
        selected = selected < this.getPagesCount()
            ? selected + 1
            : selected;
        this.setState({
            selected: selected
        }, () => {
            this
                .props
                .onChange({page: selected});
        });
    }

    prev() {
        let selected = this.state.selected;
        selected = selected > 1
            ? selected - 1
            : selected;
        this.setState({
            selected: selected
        }, () => {
            this
                .props
                .onChange({page: selected});
        });
    }

    renderItems() {
        const {selected} = this.state;
        let count = this.getPagesCount();
        return Array.from(new Array(count), (x, i) => i).map((item, index) => {
            return (
                <li className="page-item" key={index}>
                    <button
                        className={`btn btn-dark rounded-0 ${selected === index + 1
                        ? 'active'
                        : ''}`}
                        href="#"
                        onClick={() => this.onChange({item})}>{index + 1}</button>
                </li>
            )
        });
    }

    render() {
        const {count, perPage} = this.props;
        return (
            <nav aria-label="Page navigation example">
                <ul className="pagination justify-content-center">
                    <li className="page-item">
                        <button
                            className="btn btn-dark rounded-0"
                            aria-label="Previous"
                            onClick={this.prev}
                            disabled={this.state.selected === 1}>
                            <span aria-hidden="true">&laquo;</span>
                            <span className="sr-only">Previous</span>
                        </button>
                    </li>
                    {this.renderItems()}
                    <li className="page-item">
                        <button
                            className="btn btn-dark rounded-0"
                            aria-label="Next"
                            onClick={this.next}
                            disabled={this.state.selected === this.getPagesCount()}>
                            <span aria-hidden="true">&raquo;</span>
                            <span className="sr-only">Next</span>
                        </button>
                    </li>
                </ul>
            </nav>
        );
    }
}

Pagination.propTypes = {
    selected: PropTypes.number,
    perPage: PropTypes.number,
    count: PropTypes.number,
    onChange: PropTypes.func
};

Pagination.defaultProps = {
    selected: 1,
    perPage: 24,
    count: 24,
    onChange: ({page}) => {
        console.warn(`onChange prop is not defined. Page ${page}`);
    }
};

export default Pagination;


// WEBPACK FOOTER //
// ./src/Components/Pagination/Pagination.jsx